import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=35853b50&"
import script from "./guest.vue?vue&type=script&lang=ts&"
export * from "./guest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports